import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../theme/configurator-tokens';
import { MOBILE } from '../mobile.tokens';

export const ErrorScreen = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  text-align: center;
  background: ${MOBILE.screenBg};
`;

export const ErrorText = styled(Text)`
  font-size: 14px;
  color: ${CFG.danger};
`;
